import api from './api';

export const adminAnalyticsService = {
  async getAnalytics(filters = {}) {
    const params = new URLSearchParams();
    
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.paymentMethod) params.append('paymentMethod', filters.paymentMethod);
    if (filters.transactionType) params.append('transactionType', filters.transactionType);
    if (filters.transactionStatus) params.append('transactionStatus', filters.transactionStatus);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);

    const response = await api.get(`/admin/analytics?${params.toString()}`);
    return response.data;
  },

  async getSummary(days = 30) {
    const response = await api.get(`/admin/analytics/summary?days=${days}`);
    return response.data;
  },

  async exportAnalytics(filters = {}, format = 'json') {
    const params = new URLSearchParams();
    
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.paymentMethod) params.append('paymentMethod', filters.paymentMethod);
    if (filters.transactionType) params.append('transactionType', filters.transactionType);
    if (filters.transactionStatus) params.append('transactionStatus', filters.transactionStatus);
    params.append('format', format);

    if (format === 'csv') {
      const response = await api.get(`/admin/analytics/export?${params.toString()}`, {
        responseType: 'blob'
      });
      
      // Download CSV
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `analytics-${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.parentURL.removeChild(link);
    } else {
      const response = await api.get(`/admin/analytics/export?${params.toString()}`);
      return response.data;
    }
  }
};
